import React from "react";
import EmployeeListComp from "../../components/EmployeeList";

const EmployeeList = () => {
  return (
    <div>
      <EmployeeListComp />
    </div>
  );
};

export default EmployeeList;
